/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Stock_Sr_LabelInputs */

const vi_tea_grade_stock_sr_label = /** @type {(inputs: Tea_Grade_Stock_Sr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho của phân loại tại:`)
};

/**

* @param {Tea_Grade_Stock_Sr_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_sr_label = /** @type {((inputs?: Tea_Grade_Stock_Sr_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Sr_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_sr_label(inputs)
});